import { StoragePath } from './constants';
import { fireStorage } from './firebase';

export const getDownloadURL = (path) => fireStorage.ref(path).getDownloadURL();
export const getUserPhotoURL = (userID, userPhotoName) =>
  getDownloadURL(StoragePath.userPhoto(userID, userPhotoName));

export const uploadFileImage = (path, image) => fireStorage.ref(path).putString(image, 'data_url');
export const uploadPhotoURl = (userID, imgName, image) =>
  fireStorage.ref(`imagens/${userID}/prof_img_${imgName}`).putString(image, 'data_url');
